import { Link } from '@inertiajs/react';
import { formatDistanceToNow } from 'date-fns';
import type { HackerSubmissionsIndex } from '@/types';
import { SubmissionStatusPill } from './components/SubmissionStatusPill';

// /hacker/submissions — every commit the push check ran on for the team's repo, newest
// first. Each row links to /hacker/submissions/:sha for the full verdict.
export default function Index({ project, submissions }: HackerSubmissionsIndex) {
  return (
    <div className="container mx-auto max-w-4xl p-6">
      <div className="space-y-6">
        <div>
          <h1 className="font-bold text-3xl text-primary">
            Submissions
          </h1>
          <p className="mt-2 text-muted-foreground">
            {project
              ? `Cada commit que ${project.name} ha subido a su repo y su resultado.`
              : 'Tu equipo aún no tiene un proyecto.'}
          </p>
        </div>

        {submissions.length === 0 ? (
          <div className="border-2 border-primary/20 p-8 text-center text-primary/70">
            Aún no hay submissions. Haz push a la rama principal de tu repo y
            aparecerá aquí.
          </div>
        ) : (
          <ul className="divide-y divide-primary/20 border-2 border-primary bg-background/80">
            {submissions.map((submission) => (
              <li key={submission.id}>
                <Link
                  href={`/hacker/submissions/${submission.shortSha}`}
                  className="flex items-center gap-4 p-4 transition-colors hover:bg-primary/5"
                >
                  <span className="font-mono text-primary text-sm">
                    {submission.shortSha}
                  </span>
                  <span className="min-w-0 flex-1 truncate text-primary">
                    {submission.title || 'Sin mensaje'}
                  </span>
                  <span className="hidden text-primary/70 text-xs sm:inline">
                    {formatDistanceToNow(new Date(submission.createdAt), {
                      addSuffix: true,
                    })}
                  </span>
                  <SubmissionStatusPill status={submission.status} />
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
